
import React, {useState, useRef, useContext} from 'react';
import {Modal} from '@burna/monster-design-system';


const alertContext = React.createContext();
const AlertContextProvider = alertContext.Provider;

export default () => useContext(alertContext);

export const AlertContextWrapper = ({children}) => {
  const [open, setOpen] = useState(false);
  const [{title, description, type}, setTexts] = useState({title: '', description: ''});
  const timeoutRef = useRef();

  const alertWithTimeout = (title, description, timeout, type = 'success') => {
    setOpen(true);
    setTexts({title, description, type});
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setOpen(false), timeout);
  };

  const handleClose = () => {
    setOpen(false);
    clearTimeout(timeoutRef.current);
  };

  return (
    <AlertContextProvider value={alertWithTimeout}>
      {children}
      <Modal
        open={open}
        title={title}
        description={description}
        onClose={handleClose}
        type={type}
        centerAligned
      />
    </AlertContextProvider>
  );
};
